import { usePunditUserContext } from "@circle-react/contexts";

export const useIsPaywallTaxAvailable = () => {
  const { currentCommunity } = usePunditUserContext();
  return currentCommunity?.policies?.is_paywall_tax_available;
};
